import { Link } from '@tanstack/react-router';
import { Button } from 'src/shared/components/ui/buttons/button';
import { Card, CardFooter } from 'src/shared/components/ui/card';
import { Separator } from 'src/shared/components/ui/separator';
import { useAuth } from 'src/features/auth/contexts/AuthContext';
import { cn } from 'src/shared/lib/utils';

interface NoMemberProps {
  redirectUrl: string;
  className?: string;
  handleSupport: () => void;
}

export default function NoMember({ redirectUrl, className, handleSupport }: NoMemberProps) {
  const { logout } = useAuth();

  return (
    <div>
      <img src="/static/images/tekst-logo.svg" width={80} height={20} className="mx-auto mb-4" alt="Tekst logo" />
      <Card className={cn('flex flex-col px-7 pt-6 pb-2 space-y-6', className)}>
        <div className=" w-full text-center">
          <p className="text-neutral-400">Unauthorized</p>
        </div>
        <div className="text-center text-neutral-950">
          <p>You are not a member of this organisation</p>
          <Separator className="my-4 w-[50%] mx-auto" />
          <p>If you believe this is an error, please contact support by clicking the button below.</p>
        </div>

        <CardFooter className="flex-center pb-0">
          <div>
            <Button onClick={handleSupport}>Go to support</Button>
            <Link
              to={redirectUrl}
              onClick={logout}
              className="mt-5 flex-center text-neutral-400 text-xs hover:underline"
            >
              Back to login
            </Link>
          </div>
        </CardFooter>
      </Card>
    </div>
  );
}
